// 预约方法
const pub = {
  // 项目
  getProjectType(id, arr) {
    let index = arr.findIndex((a) => {
      return a.id == id;
    });
    if (index > -1) {
      let obj = {
        id: id,
        name: arr[index].name,
      };
      return obj;
    } else {
      let obj = null;
      return obj;
    }
  },
  getShopList(ids, arr) {
    let newArr = [];
    ids.forEach((a) => {
      arr.forEach((b) => {
        if (a == b.shop_id) {
          let obj = {
            shopId:b.shop_id,
            shopName:b.shop_name,
          };
          newArr.push(obj);
        }
      });
    });
    return newArr
  },
};
export default pub;
